import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Card, CardBody, Col, FormFeedback, Input, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import * as Yup from 'yup';
import { useSelector } from "react-redux";
import { GET_SURCHARGE_ALICE_DATA } from "../../../../store/Global/actiontype";
import { getAllSurchargeCategoryData } from "../../../../store/Settings/actions";
import { useUploadRateData } from "../hook/useUploadRateData";
import Select from "react-select";
import ModalAddNewCategory from "./ModalAddNewCategory";
import ModalAddNewAlias from "./ModalAddNewAlias";
import { isAnyValueEmpty } from "../../../../components/Common/CommonLogic";

const AddNewSurchargeModal = ({ modal, onCloseClick, surchargeDataCategory, tabName }) => {
    const [categoryModal, setCategoryModal] = useState(false);
    const [aliasModal, setAliasModal] = useState(false);
    const dispatch = useDispatch();
    const timerRef = useRef(null);

    const { initialValue, handleSubmit } = useUploadRateData();

    const { surchargeCategory_data, surchargeAlice_data, surchargeAlice_descri } = useSelector((state) => state.globalReducer);

    const sqlInjectionPattern = /(\b(SELECT|INSERT|UPDATE|DELETE|DROP|ALTER|CREATE|EXEC|UNION|--)\b|['";\\])/i;
    const safeString = (label) =>
        Yup.string().test(
            "no-sql-injection",
            `${label} contains potentially malicious characters or SQL keywords.`,
            function (value) {
                if (!value) return true;
                return !sqlInjectionPattern.test(value);
            }
        );
    const surchargeFormSchema = Yup.object().shape({
        surchargeCode: safeString("Surcharge Code")
            .required('Surcharge Code is required')
            .matches(/^[a-zA-Z0-9\s]+$/, 'Only alphanumeric characters are allowed')
            .max(10, 'Surcharge Code cannot exceed 10 characters'),

        surchargeDesc: safeString("Surcharge Description")
            .required('Surcharge Description is required')
            .matches(/^[a-zA-Z0-9\s]+$/, 'Only alphanumeric characters are allowed')
            .max(255, 'Description cannot exceed 255 characters'),

        surchargeCategory: Yup.string()
            .required('Surcharge Category is required'),

        surchargeAliasCode: Yup.string()
            .nullable()
            .matches(/^[a-zA-Z0-9\s]*$/, 'Only alphanumeric characters are allowed') // if filled
            .max(10, 'Alias Code cannot exceed 10 characters'),

        surchargeAliasDesc: Yup.string()
            .nullable()
            .max(100, 'Alias Description cannot exceed 100 characters'),
    });

    const formik = useFormik({
        initialValues: initialValue,
        validationSchema: surchargeFormSchema,
        onSubmit: handleSubmit,
    });

    useEffect(() => {
        dispatch(getAllSurchargeCategoryData());
        // dispatch(getTenantInfoData());
        dispatch({ type: GET_SURCHARGE_ALICE_DATA });
    }, []);

    useEffect(() => {
        console.log(tabName);
        if(tabName === 'FCL') {
            formik.setFieldValue('transportMode', 'OCEAN');
        } else {
            formik.setFieldValue('transportMode', 'AIR');

        }
        if (surchargeDataCategory) {
            console.log(surchargeDataCategory, "surchargeDataCategory")
            console.log(surchargeCategory_data, "surchargeCategory_data");
            formik.setFieldValue('surchargeCategory', surchargeCategory_data.find(item => item.value === surchargeDataCategory)?.value);
        }
    }, [surchargeDataCategory, surchargeCategory_data, tabName]);

    const onInsideCloseClick = () => {
        setCategoryModal(false);
        setAliasModal(false);
    };

    const handleOnSubmit = () => {
        formik.handleSubmit();
        timerRef.current = setTimeout(() => {
            onCloseClick();
        }, 2000);
    }

    useEffect(() => {
        return () => {
          if (timerRef.current) {
            clearTimeout(timerRef.current);
          }
        };
      }, []);

    return (
        <>
            <Modal isOpen={modal} toggle={onCloseClick} className="table_view_modal">
                <ModalHeader tag="h4">
                    Add Surcharge Category
                    <span className="close" onClick={onCloseClick}></span>
                </ModalHeader>
                <ModalBody>
                    <Row style={{ padding: '20px' }}>
                        <Col lg="12">
                            <div className="row">
                                <div className="col-md-6 col-lg-4 mb-4">
                                    <div className="row">
                                        <label className="form-label">Surcharge Code<span className='required_star'>*</span></label>
                                        <div className="">
                                            <Input
                                                type="text"
                                                name="surchargeCode"
                                                value={formik.values.surchargeCode}
                                                onChange={formik.handleChange}
                                                className="form-control"
                                                id="Surcharge_Code"
                                                placeholder="Enter Surcharge Code"
                                                invalid={formik.touched.surchargeCode && formik.errors.surchargeCode ? true : false}
                                            />
                                            {formik.touched.surchargeCode && formik.errors.surchargeCode ? (
                                                <FormFeedback> {formik.errors.surchargeCode} </FormFeedback>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-lg-4 mb-4">
                                    <div className="row">
                                        <label className="form-label">Surcharge Desc<span className='required_star'>*</span></label>

                                        <div className="">
                                            <Input
                                                type="text"
                                                name="surchargeDesc"
                                                value={formik.values.surchargeDesc}
                                                onChange={formik.handleChange}
                                                className="form-control"
                                                id="Surcharge_Desc"
                                                placeholder="Enter Surcharge Desc"
                                                invalid={formik.touched.surchargeDesc && formik.errors.surchargeDesc ? true : false}
                                            />
                                            {formik.touched.surchargeDesc && formik.errors.surchargeDesc ? (
                                                <FormFeedback> {formik.errors.surchargeDesc} </FormFeedback>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 col-lg-4 mb-4">
                                    <div className="row">
                                        <label className="form-label"> Surcharge Category<span className='required_star'>*</span></label>
                                        <div className="">
                                            <Select
                                                value={surchargeCategory_data && surchargeCategory_data?.find((item) => item.value === formik?.values?.surchargeCategory) || ""}
                                                name="surchargeCategory"
                                                options={surchargeCategory_data}
                                                placeholder={"Select Surcharge Category"}
                                                onChange={(e) => {
                                                    if (e.label === 'Add New') {
                                                        setCategoryModal(true);
                                                    }
                                                    formik.setFieldValue(`surchargeCategory`, e.value);
                                                }}
                                                isDisabled={true}
                                                classNamePrefix="select2-selection form-select"
                                                invalid={formik.touched.surchargeCategory && formik.errors.surchargeCategory ? true : false}
                                            />
                                            {formik.touched.surchargeCategory && formik.errors.surchargeCategory ? (
                                                <FormFeedback> {formik.errors.surchargeCategory} </FormFeedback>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-lg-4 mb-4">
                                    <div className="row">
                                        <label className="form-label"> Surcharge Alias Code </label>
                                        <div className="">
                                            <Select
                                                value={surchargeAlice_data && surchargeAlice_data?.find((item) => item.value === formik?.values?.surchargeAliasCode) || ""}
                                                name="surchargeAliasCode"
                                                options={surchargeAlice_data ? [...surchargeAlice_data, { label: "Add New", value: "Add New" }] : [{ label: "Add New", value: "Add New" }]}
                                                placeholder={"Select Surcharge Alias Code"}
                                                onChange={(e) => {
                                                    formik.setFieldValue(`surchargeAliasCode`, e.value);
                                                    if (e.label === 'Add New') {
                                                        setAliasModal(true);
                                                    }
                                                }}
                                                classNamePrefix="select2-selection form-select"
                                                invalid={formik.touched.surchargeAliasCode && formik.errors.surchargeAliasCode ? true : false}
                                            />
                                            {formik.touched.surchargeAliasCode && formik.errors.surchargeAliasCode ? (
                                                <FormFeedback> {formik.errors.surchargeAliasCode} </FormFeedback>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-lg-4 mb-4">
                                    <div className="row">
                                        <label className="form-label"> Surcharge Alias Desc </label>
                                        <div className="">
                                            <Select
                                                value={surchargeAlice_descri ? surchargeAlice_descri.find(obj => obj.value === formik?.values?.surchargeAliasCode) : ''}
                                                name="surchargeAliasDesc"
                                                options={surchargeAlice_descri || []}
                                                placeholder={"Select Surcharge Alias Code"}
                                                onChange={(e) => {
                                                    formik.setFieldValue(`surchargeAliasDesc`, e.value);
                                                }}
                                                isDisabled={true}
                                                classNamePrefix="select2-selection form-select"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="d-flex justify-content-center">
                                    <div className="mb-3 mx-3 d-flex justify-content-end">
                                        <button
                                            type="submit"
                                            className=" btn btn-primary"
                                            onClick={handleOnSubmit}
                                            disabled={isAnyValueEmpty(formik.values, ['surchargeAliasDesc', 'surchargeAliasCode'])}
                                        >
                                            Save
                                        </button>
                                    </div>
                                    <div className="mb-3 mx-3 d-flex justify-content-end">
                                        <button className=" btn btn-primary" onClick={() => onCloseClick()}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <ModalAddNewCategory
                        modal={categoryModal}
                        onCloseClick={onInsideCloseClick}
                    />
                    <ModalAddNewAlias modal={aliasModal} onCloseClick={onInsideCloseClick} />
                </ModalBody>
            </Modal>
        </>
    );
}
export default AddNewSurchargeModal;